import * as React from 'react';
import { observer } from 'mobx-react';
import { IShade, IShadePicker, IVtoFlag, IVtoFoundationTabs } from '../../interfaces/IVto';
import { VtoCustomShadePicker } from '../common/VtoCustomShadePicker';

interface IVtoFoundationCustomShadePicker {
    tabs: Pick<IVtoFoundationTabs, 'perfectShades' | 'allShades'>;
    vtoFoundationFeature?: IVtoFlag;
    productShadePickerProps: IShadePicker;
    sortPerfectLabels?(a: IShade, b: IShade): number;
    isMatchSaved?: boolean;
    savedMatch?: string;
}

export const VtoFoundationCustomShadePicker = observer(
    ({
        tabs,
        vtoFoundationFeature,
        productShadePickerProps,
        sortPerfectLabels,
        isMatchSaved,
        savedMatch
    }: IVtoFoundationCustomShadePicker) => {
        const { perfectShades, allShades } = tabs;
        const {
            parentProduct: { isShaded }
        } = productShadePickerProps.selectedSku;
        const hasCustomShadePicker =
            vtoFoundationFeature && vtoFoundationFeature.hasCustomShadePicker;
        const showAllShadesVariant = vtoFoundationFeature?.showAllShadesVariant;
        const showPerfectShadesLabel = vtoFoundationFeature?.showPerfectShadesLabel;
        const shadePickerProps = {
            ...productShadePickerProps,
            sortPerfectLabels,
            showAllShadesVariant,
            isMatchSaved,
            showPerfectShadesLabel,
            savedMatch
        };

        if ((perfectShades.active || allShades.active) && hasCustomShadePicker && isShaded) {
            return <VtoCustomShadePicker {...shadePickerProps} />;
        }

        return null;
    }
);
